import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { combineLatest, Observable, of } from "rxjs";
import { map } from "rxjs/operators";
import { selectPersonByLogin } from "../common/state";
import { PersonAPIActions } from "../common/state/actions";
import { AbstractPeopleService, EntityId, IPerson } from "../interfaces";
import { LogClass, Logger, LogMethod } from "../logger";

@LogClass({ source: "PersonFacade" })
@Injectable({
  providedIn: "root"
})
export class PersonFacade {
  private logger: Logger;

  constructor(private store: Store, private service: AbstractPeopleService) {}

  @LogMethod()
  public loadPersonByLogin(login: EntityId): void {
    this.store.dispatch(PersonAPIActions.loadPersonByLogin({ login }));
  }

  @LogMethod()
  public getPersonByLogin(login: EntityId): Observable<IPerson> {
    this.loadPersonByLogin(login);
    return this.store.select(selectPersonByLogin(login));
  }

  public getPersonByLogins(logins: EntityId[]): Observable<IPerson[]> {
    if (!logins || logins.length === 0) {
      return of([]);
    }

    const obs: Observable<IPerson>[] = [];
    logins.forEach((login) => {
      obs.push(this.getPersonByLogin(login));
    });

    return combineLatest(obs).pipe(
      //Ensure a valid return type
      map((persons) => {
        if (persons) {
          return persons.filter((p) => !!p);
        }
        return [];
      })
    );
  }

  @LogMethod()
  public search(query: string): Observable<IPerson[]> {
    return this.service.SearchPeople(query);
  }
}
